export default __webpack_public_path__ + "static/media/1995.87cd9bb2.png";